import loadScript from "@/utils/loadScript";
import { MarkerClusterer } from "@googlemaps/markerclusterer";

export default function (dom, opts) {
    let options = {
        mapSel: '#map',
        locations: [],

        ...opts
    };

    async function init() {
        await loadScript(`https://maps.googleapis.com/maps/api/js?key=${options.apiKey}`);

        let map = new google.maps.Map(
            dom.querySelector(options.mapSel),
            {
                zoom: 8,
                // center of switzerland
                center: {lat: 46.801111, lng: 8.226667},
                // style options
                styles: [
                    {
                        "featureType": "all",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#dad9d6"
                            },
                            {
                                "gamma": "10.00"
                            },
                            {
                                "saturation": "0"
                            },
                            {
                                "lightness": "0"
                            },
                            {
                                "weight": "1"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.province",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#000000"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.natural",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ebebeb"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.natural.terrain",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#e5e5e5"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.attraction",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#e2e1e1"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.business",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#e2e1e1"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.government",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#e2e1e1"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.medical",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#e2e1e1"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#9ed6c1"
                            },
                            {
                                "saturation": "0"
                            },
                            {
                                "weight": "1"
                            },
                            {
                                "lightness": "48"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.place_of_worship",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#e2e1e1"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.school",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#e2e1e1"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.sports_complex",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#e2e1e1"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "all",
                        "stylers": [
                            {
                                "saturation": -100
                            },
                            {
                                "lightness": 45
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway.controlled_access",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "saturation": "100"
                            },
                            {
                                "color": "#fcbbd7"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway.controlled_access",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#fbb6b6"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "color": "#fbb6b6"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.station.bus",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "saturation": "100"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#568ea5"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#99dcf5"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#2baedf"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    }
                ]
            }
        );

        let openInfoWindow;
        let markers = [];

        options.locations.forEach((location, index) => {
            const locationMarker = {
                url: `/files/fwg/map-icons/FWG-MapIcons-${location.brand}.svg`,
                scaledSize: new google.maps.Size(20, 35),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(10, 30)
            };

            let storeInfo =
                `<div class="store-info">
                 <h6 class="store-info__name">${options.brandNames[location.brand]}</h6>
                 <div class="store-info__title">${location.title}</div>
                 <div class="store-info__content">
                 <p>${location.street}<br>${location.zip}&nbsp;${location.city}</p>
                 <p><a href="${location.web}" class="store-info__link" target="_blank">${location.web.replace(/^https?:\/\/(www\.)?/ig, '')}</a></p>
                 <p>Telefon: <a href="tel:${location.tel}" class="store-info__phone">${location.tel}</a></p>
                 <p>E-Mail: <a href="mailto:${location.email}" class="store-info__email">${location.email}</a></p>
                 </div>
                 </div>`;

            // Map Marker
            let marker = new google.maps.Marker({
                position: {lat: +location.lat, lng: +location.lng},
                //map: map,
                icon: locationMarker,
                animation: google.maps.Animation.DROP,
                title: `${options.brandNames[location.brand]}`
            });

            let infoWindow = new google.maps.InfoWindow({
                content: storeInfo
            });

            google.maps.event.addListener(marker, 'click', () => {
                if (openInfoWindow) {
                    // Always close previous Info Window
                    openInfoWindow.close();
                }
                infoWindow.setContent(storeInfo);
                openInfoWindow = infoWindow;
                infoWindow.open(map, marker);
            });

            markers.push(marker);
        })

        new MarkerClusterer({
            map,
            markers,
            renderer: {
                render({ count, position }, stats) {
                    // create marker using svg icon
                    return new google.maps.Marker({
                        position,
                        icon: {
                            url: `/files/fwg/map-icons/cluster-icon.svg`,
                            scaledSize: new google.maps.Size(35, 35),
                        },
                        label: {
                            text: String(count),
                            color: "#000",
                            fontSize: "12px",
                            fontWeight: 'bold',
                        },
                        title: `Cluster of ${count} markers`,
                        // adjust zIndex to be above other markers
                        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                    });
                }
            }

        })

    }


    init()

}
